import { render, staticRenderFns } from "./sales.vue?vue&type=template&id=19c15554&scoped=true"
import script from "./sales.vue?vue&type=script&lang=ts"
export * from "./sales.vue?vue&type=script&lang=ts"
import style0 from "./sales.vue?vue&type=style&index=0&id=19c15554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c15554",
  null
  
)

export default component.exports